import { useEffect, useState } from 'react';

export const useFetch = <T, P>(
  url: string | null,
  requestInit?: RequestInit,
): {
  data: T | null;
  loading: boolean;
  error: P | null;
  refetch: () => void;
} => {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<P | null>(null);
  const [fetchCount, setFetchCount] = useState(0);

  const refetch = () => setFetchCount(fetchCount + 1);

  useEffect(() => {
    setData(null);
    setError(null);

    if (url) {
      // initialize
      new Promise<Response>((resolve, reject) =>
        fetch(url, requestInit)
          .then((res) => {
            if (res.ok) {
              resolve(res);
            }
            reject(res);
          })
          .catch((err) => {
            throw err;
          }),
      )
        .then((res) => res.json())
        .catch((err: Response) =>
          err
            .json()
            .then((res: P) => setError(res))
            .catch((err) => setError(err)),
        )
        .then((res) => setData(res))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [url, fetchCount]);

  return {
    data,
    error,
    loading,
    refetch,
  };
};
